import { useNavigate } from "@tanstack/react-router"

type Order = "asc" | "desc"

type SortProps<T extends string[] | readonly string[]> = {
  fields: T
  search: { field: T[number]; order: Order }
  fullPath: string
}

function getOrderBy(field: string, search: { field: string; order: Order }) {
  if (search.field !== field) return "asc"
  return search.order === "asc" ? "desc" : "asc"
}

export function useSortBy<T extends string[] | readonly string[]>({
  search,
  fullPath,
  fields,
}: SortProps<T>) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigate = useNavigate({ from: fullPath as any })

  const onSort = (field: T[number]) => {
    const newSearch = { ...search }
    newSearch.field = field
    newSearch.order = getOrderBy(field, search)

    navigate({
      // TODO: Remove this once the type is fixed
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      search: newSearch as any,
    })
  }

  return {
    fields,
    onSort,
    sortBy: {
      field: search.field,
      order: search.order,
    },
  }
}
